<template>
  <div class="app">
<!--
    <template v-if="!this.$store.state.isSubmitted">
      <div class="bghome"></div>
      <FModal></FModal>
    </template>
    <template v-else>

      <Header/>-->
      <main class="App__main">
        <transition name="fade" mode="out-in">
          <router-view/>
        </transition>
      </main>
<!--
    </template>
-->
  </div>
</template>





<script>

  /*import Header from "../src/components/Header.vue";
  import FModal from "@/components/FModal";*/


  export default {
    name: "App",
    components: {
      /*Header,
      FModal*/
      },
  }

</script>







<style>

  body, html {
      margin: 0;
      padding: 0;
      scroll-behavior: smooth;

      background-color: #004550;
  }


  /* Page Transitions */
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.2s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

</style>
